import React from 'react';
import { TableFilter } from 'components/UI/Table';
import { ExcelExportButton } from './ExcelExportButton';
import { applyStoreAccessFilter } from './tableUtils';

/**
 * Создает компонент Excel экспорта для SessionsBroken с фильтром и проверкой прав доступа
 * @param filter - текущий фильтр
 * @param user - текущий пользователь
 * @param store - текущий магазин
 */
export const createSessionsBrokenExcelExport = (filter: TableFilter, user: any, store: any) => () => {
	const newFilters = applyStoreAccessFilter(filter, user, store);
	return <ExcelExportButton filter={newFilters} endpoint="/api/breach/reportToXls" filename="sessionsBroken.xlsx" />;
};

/**
 * Создает компонент Excel экспорта для PhotoViolations с фильтром и проверкой прав доступа
 * @param filter - текущий фильтр
 * @param user - текущий пользователь
 * @param store - текущий магазин
 */
export const createPhotoViolationsExcelExport = (filter: TableFilter, user: any, store: any) => () => {
	const newFilter = applyStoreAccessFilter(filter, user, store);
	return (
		<ExcelExportButton
			filter={newFilter}
			endpoint="/api/breach/reportToXls"
			filename="breachs.xlsx"
			additionalParams="onlyWithPhoto"
		/>
	);
};

/**
 * Создает компонент Excel экспорта для Sessions с фильтром
 * @param filter - текущий фильтр
 * @param storeId - ID магазина (опционально)
 */
export const createSessionsExcelExport = (filter: TableFilter, storeId?: string | number) => () =>
	(
		<ExcelExportButton
			filter={filter}
			endpoint="/api/session/exportToXls"
			filename="session.xlsx"
			additionalParams={storeId ? `storeId=${storeId}` : undefined}
		/>
	);
